import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class EstateTaskWillStatus extends Enum {
  static TODO = {
    key: 'todo',
    get value() {
      return Lang.t('estate.to-do');
    },
    color: '#7E84A3'
  };

  static IN_REVIEW = {
    key: 'in_review',
    get value() {
      return Lang.t('estatetask.in-review');
    },
    color: '#EE964B'
  };

  static ACCEPTED = {
    key: 'accepted',
    get value() {
      return Lang.t('estatetask.accepted');
    },
    color: '#61D098'
  };

  static REASSESSING = {
    key: 'reassessing',
    get value() {
      return Lang.t('estatetask.reassessing');
    },
    color: '#F97068'
  };
}
